import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables,
    isEmptyVariable, isEmptyArray,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import {DialogSaveButton} from '../../../common/Global/globalStyles.style';
import AlertDialog from '../../../common/AlertDialog';

let userDetails = getLocalStorageVariables();

class UpdateReviewStatusDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,

            functionName:"",
            functionShortName:"",
            formErrors:{},
            submitClickedAtleastOnce:false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showCreateDialog){

            if(this.props.isEdit){
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    functionName:this.props.functionName,
                    functionShortName:isEmptyVariable(this.props.functionShortName)?"":this.props.functionShortName,
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                })
            }else{
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    functionName:"",
                    functionShortName:"",
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                })
            }
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.handleCreateMaster();
        }
    }

    handleCreateDialogClose = () =>{
        this.setState({
            functionShortName:""
        })
        this.props.handleAddEditDialogClose(false);
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    handleCreateMaster = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};

        if(isEmptyVariable(this.state.functionName)){
            isError = true;
            FormErrorsTemp['functionName'] = "Please enter function name";
        }
        // if(isEmptyVariable(this.state.functionShortName)){
        //     isError = true;
        //     FormErrorsTemp['functionShortName'] = "Please enter function short name";
        // }
        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

        }else{
            let url = "";
            let postParam = {
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            }

            if(this.props.isEdit){
                url = Constants.UpdateFunction;
                let funcObj = {
                    functionId:this.props.selectedId,
                    functionName:this.state.functionName,
                    functionShortName:this.state.functionShortName
                }
                postParam.function = JSON.stringify(funcObj);
                postParam.rootFunctionId = this.props.rootFunctionId;
            }else{
                postParam.departmentId = this.props.departmentId;
                if(this.props.createNodeType === "root"){
                    url = Constants.AddRootFunction;
                    let funcObj = {
                        functionId:0,
                        functionName:this.state.functionName,
                        functionShortName:this.state.functionShortName
                    }
                    postParam.function = JSON.stringify(funcObj);

                }else if(this.props.createNodeType === "child"){
                    url = Constants.AddChildFunction;
                    let funcObj = {
                        functionId:0,
                        functionName:this.state.functionName,
                        functionShortName:this.state.functionShortName
                    }

                    postParam.childFunction = JSON.stringify(funcObj);
                    postParam.parentFunctionId = this.props.relativeFunctionId;
                    postParam.rootFunctionId = this.props.rootFunctionId;
                    
                }else if(this.props.createNodeType === "sibling"){
                    url = Constants.AddSiblingFunction;

                    let funcObj = {
                        functionId:0,
                        functionName:this.state.functionName,
                        functionShortName:this.state.functionShortName
                    }

                    postParam.siblingFunction = JSON.stringify(funcObj);
                    postParam.targetFunctionId = this.props.relativeFunctionId;
                    postParam.rootFunctionId = this.props.rootFunctionId;
                }
            }

            fetch(url,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(postParam)
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    let createNodeTypeTemp = this.props.createNodeType;

                    if(createNodeTypeTemp === "root"){
                        this.setState({
                            showLoader:false,
                            functionName:"",
                            functionShortName:"",
                            formErrors:{},
                        },() => {
                            this.props.handleAddEditDialogClose(true);
                        });
                    }else if(createNodeTypeTemp === "child" ||
                    createNodeTypeTemp === "sibling"){
                        this.setState({
                            showLoader:false,
                            functionName:"",
                            functionShortName:"",
                            formErrors:{},
                        },() => {
                            this.props.handleAddEditDialogClose(true);
                        });
                    }
                }else{
                    this.setState({
                        showLoader:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    });
                }
            });
        }
    }

    render() {
        return(
            <>
            <Modal className="custom-dialog" show={this.props.showCreateDialog} backdrop="static">
                <Modal.Header>
                    <h5>{this.props.isEdit?"Edit Function":"Add Function"}</h5>
                    <button 
                        onClick={this.handleCreateDialogClose}
                        type="button" data-dismiss="modal">
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div class="modal-body">
                    <div class="addnew-modal-form">
                        <div class="addnew-modal-form-group">
                            <p>Function Short Name</p>
                            <input type="text" placeholder="Enter Function Short Name" onKeyPress={this.onEnterBtnPress} spellCheck="true" 
                            name="functionShortName" value={this.state.functionShortName} onChange={this.handleChange}/>
                            {/* {
                                !isEmptyVariable(this.state.formErrors['functionShortName']) &&
                                <span class="cm-error">{this.state.formErrors['functionShortName']}</span>
                            } */}
                        </div>
                        <div class="addnew-modal-form-group">
                            <p>Function Name*</p>
                            <input type="text" placeholder="Enter Function Name" onKeyPress={this.onEnterBtnPress} spellCheck="true" 
                            name="functionName" value={this.state.functionName} onChange={this.handleChange}/>
                            {
                                !isEmptyVariable(this.state.formErrors['functionName']) &&
                                <span class="cm-error">{this.state.formErrors['functionName']}</span>
                            }
                        </div>
                    </div>
                    <div class="modal-close-save">
                        <div class="close-save-col">
                            <button onClick={this.handleCreateDialogClose} type="button" class="modal-close">Cancel</button>
                            <DialogSaveButton 
                            themeSettings={this.props.themeSettings}
                            onClick={this.handleCreateMaster} type="button">
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                            </DialogSaveButton>
                        </div>
                    </div>
                </div>
            </Modal>
            <AlertDialog
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type={Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                themeSettings={this.props.themeSettings}
            />
            </>
        );
    }
}

export default UpdateReviewStatusDialog;